import { Box, Center, Flex, Square, Text } from "@chakra-ui/react";
import React from "react";
import {
  VIEW_WIDTH,
  VIEW_WIDTH_SM,
} from "../../../shared/constants/views.constant";
import { InstagramFetch } from "../../InstagramFetch/InstagramFetch";

export const CollectionPage = () => {
  return (
    <Box
      width={{ base: VIEW_WIDTH_SM, md: VIEW_WIDTH }}
      height="90vh"
      bg="#fff"
      // mt="2.75em"
      borderRadius={"15px"}
      shadow="lg"
    >
      <Flex margin={0}>
        
        {/* <InstagramFetch/> */}
      </Flex>
    </Box>
  );
};
